export default __webpack_public_path__ + "static/sample1-d29ddbd81eab398b600b7f125cd74fff.webp";